import { useParams } from "react-router-dom";
import { useMemo } from "react";
import { TimeSeriesChartItem } from "@iliotech/widgets";
import { ClickableLegendItem } from "@iliotech/component-library";
import { useGlobalCurrency } from "@iliotech/data-wire";
import { useMonthlyPnlByAttribution } from "@iliotech/data-wire/src/reactHooks/api/useMonthlyPnlByAttribution";
import { ITimePeriod } from "@iliotech/data-wire/src/reactHooks/context/types";
const PRICE_COLOR = "#A8E6AE";
const FX_COLOR = "#A8C4E6";
const INCOME_COLOR = "#286B67";

export const usePnlByAttribution = (overriddenPeriod?: ITimePeriod) => {
  const { portfolioId = "" } = useParams();
  const pnlByAttribution = useMonthlyPnlByAttribution(
    portfolioId,
    overriddenPeriod
  );
  const { currencyFormatter } = useGlobalCurrency();

  const { data, isLoading, legend } = useMemo(() => {
    const data: TimeSeriesChartItem[] = [
      {
        category: "Fx",
        entries:
          pnlByAttribution?.data?.data?.data?.map((entry) => ({
            date: new Date(entry.valuationDate),
            value: entry.fx,
          })) || [],
        color: FX_COLOR,
      },
      {
        category: "Income",
        entries:
          pnlByAttribution?.data?.data?.data?.map((entry) => ({
            date: new Date(entry.valuationDate),
            value: entry.income,
          })) || [],
        color: INCOME_COLOR,
      },
      {
        category: "Price",
        entries:
          pnlByAttribution?.data?.data?.data?.map((entry) => ({
            date: new Date(entry.valuationDate),
            value: entry.price,
          })) || [],
        color: PRICE_COLOR,
      },
    ];

    const legend: ClickableLegendItem[] = [
      {
        label: "Total",
        value: currencyFormatter(pnlByAttribution?.data?.data?.total || 0),
      },
      {
        label: "Price",
        color: PRICE_COLOR,
        value: currencyFormatter(pnlByAttribution?.data?.data?.priceTotal || 0),
      },
      {
        label: "Fx",
        color: FX_COLOR,
        value: currencyFormatter(pnlByAttribution?.data?.data?.fxTotal || 0),
      },
      {
        label: "Income",
        color: INCOME_COLOR,
        value: currencyFormatter(
          pnlByAttribution?.data?.data?.incomeTotal || 0
        ),
      },
    ];

    return {
      data,
      isLoading: pnlByAttribution?.isLoading,
      legend,
    };
  }, [pnlByAttribution.data, currencyFormatter]);

  return { data, isLoading, legend, currencyFormatter };
};
